export default __webpack_public_path__ + "static/media/bigCircle.5d2d160a.png";